import axios from "axios";
import TokenService from "./token.service";
import { apiConfig } from "../config/api.config";

const instance = axios.create({
  baseURL: apiConfig.baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach JWT token to every request if available
instance.interceptors.request.use(
  (config) => {
    const token =
      TokenService.getLocalAccessToken && TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
